import { ContentMap } from '../../types';
import { hanoiTrainStreetAndTrainNightMarketContent } from '../common/hanoi-train-street-and-train-night-market';
import { bangkokMallsContent } from './bangkok-malls';
import { bangkokMarketsContent } from './bangkok-markets';
import { bangkokTransportationContent } from './bangkok-transportation';
import { chiangMaiAttractionsContent } from './chiang-mai-attractions';
import { chiangMaiMarketsContent } from './chiang-mai-markets';
import { chiangMaiPaiChiangRaiRoadAttractionsContent } from './chiang-mai-pai-chiang-rai-road-attractions';
import { chiangRaiToChiangMaiContent } from './chiang-rai-to-chiang-mai';
import { chiangRaiToGoldenTriangleContent } from './chiang-rai-to-golden-triangle';
import { floatingMarketContent } from './floating-market';
import { generalThailandContent } from './general-thailand';
import { huaHinAttractionsContent } from './hua-hin-attractions';
import { khaosanRoadContent } from './khaosan-road';
import phuketFamilyHotelsContent from './phuket-family-hotels';
import { relatedArticlesSlugsMap } from './relatedArticlesSlugsMap';
import { thailandTaxRefundContent } from './tax-refund';
import { thailandMyanmarBorderTripContent } from './thailand-mianmar-border-trip';

export type ThailandArticleKey =
  | 'thailand-tax-refund'
  | 'bangkok-markets'
  | 'bangkok-transportation'
  | 'chiang-mai-markets'
  | 'bangkok-malls'
  | 'general-thailand'
  | 'khaosan-road'
  | 'floating-market'
  | 'chiang-mai-attractions'
  | 'chiang-mai-pai-chiang-rai-road-attractions'
  | 'thailand-myanmar-border-trip'
  | 'chiang-rai-to-golden-triangle'
  | 'chiang-rai-to-chiang-mai'
  | 'train-night-market'
  | 'hua-hin-attractions'
  | 'phuket-family-hotels';

export const thailandArticlesContentMap: ContentMap = {
  'thailand-tax-refund': thailandTaxRefundContent,
  'bangkok-markets': bangkokMarketsContent,
  'bangkok-transportation': bangkokTransportationContent,
  'chiang-mai-markets': chiangMaiMarketsContent,
  'bangkok-malls': bangkokMallsContent,
  'general-thailand': generalThailandContent,
  'khaosan-road': khaosanRoadContent,
  'floating-market': floatingMarketContent,
  'chiang-mai-attractions': chiangMaiAttractionsContent,
  'chiang-mai-pai-chiang-rai-road-attractions':
    chiangMaiPaiChiangRaiRoadAttractionsContent,
  'thailand-myanmar-border-trip': thailandMyanmarBorderTripContent,
  'chiang-rai-to-golden-triangle': chiangRaiToGoldenTriangleContent,
  'chiang-rai-to-chiang-mai': chiangRaiToChiangMaiContent,
  'train-night-market': hanoiTrainStreetAndTrainNightMarketContent,
  'hua-hin-attractions': huaHinAttractionsContent,
  'phuket-family-hotels': phuketFamilyHotelsContent,
};

export const thailandArticlesCardData = [
  {
    title: 'תאילנד – תעודת זהות',
    description:
      'תאילנד – ארץ החופשיים: נופים טרופיים, תרבות עשירה, איים עוצרי נשימה וקהילה יהודית חמה בלב דרום-מזרח אסיה',
    imageUrl: '/images/thailand/general-thailand/general-thailand-preview.jpeg',
    date: '15.03.2024',
    readTime: '20',
    slug: 'general-thailand',
  },
  {
    title: 'קניונים בבנגקוק – חוויית קניות לכל טעם וסגנון',
    description:
      'מדריך הקניונים של בנגקוק – ממותגי יוקרה ועד מציאות בזול, כל מה שצריך לדעת כדי להפוך את הקניות בעיר לחוויה מושלמת',
    imageUrl: '/images/thailand/bangkok-malls/bangkok-malls-preview.jpeg',
    date: '15.03.2024',
    readTime: '20',
    slug: 'bangkok-malls',
  },
  {
    title: 'החזרי מס לתיירים בתאילנד',
    description:
      'קונים בתאילנד? כך תקבלו החזר מע"מ בקלות – מדריך מעשי שיחסוך לכם כסף וטעויות בשדה התעופה',
    imageUrl: '/images/thailand/tax-refund/tax-refund-preview.jpeg',
    date: '01.03.2024',
    readTime: '8',
    slug: 'thailand-tax-refund',
  },
  {
    title: 'שווקים בבנגקוק – חוויית קניות שאין שני לה',
    description:
      "מהשווקים הססגוניים של צ'אטוצ'אק ועד לצ'יינה טאון ולילות הקאוסאן – המדריך המלא לשווקים הכי שווים בבנגקוק",
    imageUrl: '/images/thailand/bangkok-markets/bangkok-markets-preview.jpeg',
    date: '01.01.2024',
    readTime: '12',
    slug: 'bangkok-markets',
  },
  {
    title: 'התחבורה הציבורית בבנגקוק',
    description:
      'כל הדרכים בבנגקוק – מדריך מקיף לתחבורה ציבורית בעיר שתעזור לכם לנוע בקלות, לחסוך זמן וליהנות מכל רגע',
    imageUrl:
      '/images/thailand/bangkok-transportation/bangkok-transportation-preview.jpeg',
    date: '22.01.2024',
    readTime: '2',
    slug: 'bangkok-transportation',
  },
  {
    title: 'שווקים בצ׳אנג מאי',
    description:
      "השווקים הכי שווים בצ'אנג מאי – מדריך לשווקי לילה ויום שלא כדאי לפספס בבירת הצפון",
    imageUrl:
      '/images/thailand/chiang-mai-markets/chiang-mai-markets-preview.jpeg',
    date: '10.03.2024',
    readTime: '2.5',
    slug: 'chiang-mai-markets',
  },
  {
    title: 'רחוב הקאוסאן והמרחב הסמוך אליו',
    description:
      'הלב הפועם של התרמילאים בבנגקוק, עם שווקים ביום, מסיבות בלילה ואווירה שאין בשום מקום אחר',
    imageUrl: '/images/thailand/khao-san/khao-san-preview.jpg',
    date: '10.03.2024',
    readTime: '3.5',
    slug: 'khaosan-road',
  },
  {
    title: 'שווקים ייחודיים בקרבת בנגקוק – חוויה אותנטית וייחודית',
    description:
      'טיול יום מבנגקוק לשלושה מהשווקים המיוחדים בתאילנד – שוק צף, שוק רכבת ושמורת קופים שוחים – חוויה אותנטית, צבעונית ובלתי נשכחת',
    imageUrl: '/images/thailand/floating-market/floating-market-preview.jpeg',
    date: '10.03.2024',
    readTime: '3',
    slug: 'floating-market',
  },
  {
    title: "אטרקציות נוספות בצ'אנג מאי והסביבה",
    description:
      "אטרקציות מגוונות בצ'אנג מאי – מקדשים, מפלים, ספארי לילי וטבע מרהיב בלב הצפון התאילנדי",
    imageUrl:
      '/images/thailand/chiang-mai-attractions/chiang-mai-attractions-preview.jpeg',
    date: '10.03.2024',
    readTime: '2.5',
    slug: 'chiang-mai-attractions',
  },
  {
    title: "אטרקציות על אם הדרך מצ'אנג מאי לפאי ולצ'אנג ראי",
    description:
      "בין צ'אנג מאי לצפון: מסלולי דרך מרהיבים עם מפלים, כפרים אתניים, גייזרים, קניונים וחוויות בלתי נשכחות בטבע התאילנדי",
    imageUrl:
      '/images/thailand/chiang-mai-pai-chiang-rai-road/chiang-mai-pai-chiang-rai-road-preview.jpeg',
    date: '10.03.2024',
    readTime: '3',
    slug: 'chiang-mai-pai-chiang-rai-road-attractions',
  },
  {
    title: 'טיול יום בצפון תאילנד לאורך כביש 1149 - גבול תאילנד-מיאנמר',
    description:
      "מסלול יום קסום לאורך הגבול עם מיאנמר: תצפיות, גנים מלכותיים, כפרים מסורתיים ושוק בגבול – חוויה צפונית בלתי נשכחת מצ'אנג ראי",
    imageUrl:
      '/images/thailand/thailand-mianmar-border-trip/thailand-mianmar-border-trip-preview.jpeg',
    date: '10.03.2024',
    readTime: '3.5',
    slug: 'thailand-myanmar-border-trip',
  },
  {
    title: "טיול יום מצ'אנג ראי למשולש הזהב – חוויה היסטורית ותרבותית",
    description:
      'מסע יומי מרתק ממשולש הזהב לצ׳יאנג סאן: שבטי הרים, שווקי גבול, שייט בנהר המקונג ומעיינות חמים – כל הקסם של צפון תאילנד ביום אחד',
    imageUrl:
      '/images/thailand/chiang-rai-to-golden-triangle/chiang-rai-to-golden-triangle-preview.jpeg',
    date: '10.03.2024',
    readTime: '3',
    slug: 'chiang-rai-to-golden-triangle',
  },
  {
    title: "טיול מצ'אנג ראי לצ׳אנג מאי",
    description:
      "מסלול טבע קסום מצ'אנג ראי לצ'אנג מאי: מפלים, פארקים, מעיינות חמים ונופים עוצרי נשימה – חוויית מעבר בלתי נשכחת בין שתי ערי הצפון",
    imageUrl:
      '/images/thailand/chiang-rai-to-chiang-mai/chiang-rai-to-chiang-mai-preview.jpeg',
    date: '10.03.2024',
    readTime: '3',
    slug: 'chiang-rai-to-chiang-mai',
  },
  {
    title:
      'שוק הרכבת בתאילנד ורחוב הרכבת בהאנוי – חוויות מסילה שלא תרצו לפספס!',
    description:
      'שתי חוויות רכבת בלתי נשכחות בוייטנאם ובתאילנד – אחת שוק ססגוני, השנייה רחוב בילוי תיירותי – שתיהן עם רכבת שחוצה ממש לצידכם',
    imageUrl:
      '/images/common/train-night-market/train-night-market-preview.jpeg',
    date: '10.03.2024',
    readTime: '3',
    slug: 'train-night-market',
  },
  {
    title: 'אטרקציות בהואה הין – חוויית טבע ונופש מרהיבה בסביבת הואה הין',
    description:
      'שילוב מושלם של חופים יפיפיים, שמורות טבע, מקדשים מרשימים, שווקים צבעוניים ואטרקציות לכל גיל – האווירה, הנופים והשלווה הופכים את הואה הין לפנינה תאילנדית אמיתית',
    imageUrl:
      '/images/thailand/hua-hin-attractions/hua-hin-attractions-preview.jpeg',
    date: '10.03.2024',
    readTime: '3',
    slug: 'hua-hin-attractions',
  },
  {
    title: 'מלונות מומלצים למשפחות בפוקט',
    description:
      'מתכננים חופשה משפחתית בפוקט? ריכזנו עבורכם את המלונות הכי מומלצים למשפחות, עם טיפים שימושיים, מידע לפי אזורים וכל מה שצריך לדעת לפני שסוגרים חופשה',
    imageUrl:
      '/images/thailand/phuket-family-hotels/phuket-family-hotels-preview.jpg',
    date: '01.05.2025',
    readTime: '3.5',
    slug: 'phuket-family-hotels',
  },
].map((article) => ({
  ...article,
  articleLink: `/international/thailand/article/${article.slug}`,
  relatedArticlesSlugs:
    relatedArticlesSlugsMap[
      article.slug as keyof typeof relatedArticlesSlugsMap
    ],
}));
